module.exports = __webpack_public_path__ + "static/img/zxjt-bg.884d548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zxjt-bg.png
// module id = Ob/V
// module chunks = 3